import { lazy } from "react";

const Globo_Patient_Login = lazy(() => import("@/pages/Authentication/Login"));
const Globo_Patient_Dashboard = lazy(() => import("@/pages/GloboPatient/Dashboard/index"));
const Globo_Patient_Orders = lazy(() => import("@/pages/GloboPatient/Orders/index"));
const Globo_Patient_Shop = lazy(() => import("@/pages/GloboPatient/Shops"));
/* const Globo_Patient_Signup = lazy(() => import("@/pages/GloboPatient/Authentication/Signup/index")); */

export var globoPatientPublicRoutes = [
  { path: "/login", component: <Globo_Patient_Login /> },
   /* { path: "/signup", component: <Globo_Patient_Signup /> }, */
];

export var globoPatientProtectedRoutes = [
  { path: "/globo-patient/dashboard", component: <Globo_Patient_Dashboard /> },
  { path: "/globo-patient/orders", component: <Globo_Patient_Orders /> },
  { path: "/globo-patient/shop", component: <Globo_Patient_Shop /> },
];